import {
  DishComponent,
  DishModification,
  DishVariation,
  Ingredient,
  Product,
  SemiProduct,
  DbDocument,
} from '../apiTypes';
import { Map } from './map';

export const getPriceByUnit = (price: number, ingredient?: Ingredient | Product | SemiProduct) => {
  if (ingredient && 'qpp' in ingredient && ingredient.qpp) {
    return price / ingredient.qpp;
  }
  if (ingredient?.unit === 'g' || ingredient?.unit === 'ml') {
    return price / 1000;
  }
  return price;
};

export const getComponentCost = (
  component: DishComponent | undefined,
  productsMap: Map<DbDocument<Product>>,
  semiProductsMap: Map<DbDocument<SemiProduct>>,
  isPrev?: boolean
): number => {
  if (component?.type === 'product') {
    const product = productsMap[component.id];
    const price = (isPrev ? product?.prevPrice : product?.price) || 0;
    const cost = getPriceByUnit(price, product) * component.qnt;
    return cost;
  }

  if (component?.type === 'semiProduct') {
    const semiProduct = semiProductsMap[component.id];

    if (!semiProduct) {
      return 0;
    }

    const semiProductBatchCost = semiProduct.components.reduce((acc, item) => {
      const cost = getComponentCost(item, productsMap, semiProductsMap);
      return acc + cost;
    }, 0);

    const semiProductUnitCosts = semiProductBatchCost / (semiProduct.batchVolume || 1);

    return semiProductUnitCosts * component.qnt;
  }

  return 0;
};

type GetOrderItemCostProps = {
  components: DishComponent[];
  variation?: DishVariation | null;
  modifications?: DishModification[] | null;
  productsMap: Map<DbDocument<Product>>;
  semiProductsMap: Map<DbDocument<SemiProduct>>;
};

export const getOrderItemCost = ({
  components,
  variation,
  modifications,
  productsMap,
  semiProductsMap,
}: GetOrderItemCostProps) => {
  const mainCost = components.reduce((acc, c) => acc + getComponentCost(c, productsMap, semiProductsMap), 0);
  const variationCost =
    variation?.components.reduce((acc, c) => acc + getComponentCost(c, productsMap, semiProductsMap), 0) || 0;
  const modificationsCost =
    modifications?.reduce(
      (totalAcc, mod) =>
        totalAcc + mod.components.reduce((acc, c) => acc + getComponentCost(c, productsMap, semiProductsMap), 0),
      0
    ) || 0;

  return Math.round(mainCost + variationCost + modificationsCost);
};
